var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckedCircleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 49"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "checked-circle-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .963h48v48H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#checked-circle-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.628 7.525a1.81 1.81 0 0 0-2.558-.004L22.368 29.168l-7.83-8.505a1.81 1.81 0 0 0-2.662 2.451l9.105 9.889a1.806 1.806 0 0 0 2.608.056l23.035-22.975c.708-.705.71-1.851.004-2.558"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.19 23.154c-.998 0-1.808.81-1.808 1.809 0 11.239-9.143 20.382-20.382 20.382-11.238 0-20.382-9.143-20.382-20.382C3.618 13.725 12.762 4.58 24 4.58a1.809 1.809 0 1 0 0-3.618c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.767 24-24c0-1-.81-1.81-1.81-1.81"
}))));
export { SvgCheckedCircleIcon as ReactComponent };
export default __webpack_public_path__ + "06a2f00b678f86043307a57fa4d95da7.svg";